import { Switch } from "antd";
import React from "react";

export default function SwitchActiveAndDeactiveProducts({ product, setListToUpdate, listToUpdate }) {
    
    const [isEnable, setIsEnable] = React.useState(product.status === "active" ? true : false); 

    const handleSwitchChange = (checked) => {
        setIsEnable(checked);

        const updatedProduct = { 
          id: product.id, 
          product_id: product.product_id,
          is_enabled: checked 
        };

        const identifier = updatedProduct.id;

        if (!identifier) {
            return;
        }
        const exists = listToUpdate.some(p => p.id === identifier);

        if (exists) {
            const newList = listToUpdate.map(p => 
                p.id === identifier ? updatedProduct : p
            );
            setListToUpdate(newList);
        } else {
            setListToUpdate([...listToUpdate, updatedProduct]);
        }
    };

    return (
        <Switch 
            checked={isEnable} 
            onChange={handleSwitchChange} 
            checkedChildren="Inativar" 
            unCheckedChildren="Ativar" 
        />
    );
}
